import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { DialogOverviewExampleDialogComponent } from "../../dialog-overview-example-dialog/dialog-overview-example-dialog.component";
import { BackendApiService } from "../../../app/services/backend-api.service";
import { BaseUrlConstantsService } from "../../../app/services/base-url-constants.service";
import { ChangeUsersService } from "../../../app/services/change-users.service";
import { from } from "rxjs";
import { debounce } from "rxjs/operators";
import { ConvertDatetimePipe } from "../../../app/convert-datetime.pipe";
import { CommonModule } from "@angular/common";
import { MatMenu, MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
@Component({
  selector: "app-site-and-groups",
  templateUrl: "./site-and-groups.component.html",
  styleUrls: ["./site-and-groups.component.scss"],
  standalone:true,
  imports:[CommonModule,MatMenuModule,MatButtonModule,MatIcon]
})
export class SiteAndGroupsComponent implements OnInit {
  public deleteSiteUrl = BaseUrlConstantsService.DELETE_SITE;
  private allSitesUrl = BaseUrlConstantsService.GET_SITES;
  public userListingUrl = BaseUrlConstantsService.END_USER_LIST;
  public siteUsersListingUrl = BaseUrlConstantsService.SITE_USERS_LIST;
  public applicationDeleteUrl = BaseUrlConstantsService.DELETE_APPLICATIONS;
  public pid: boolean;
  public searchedItem: string = "";
  public showList: boolean = true;
  public emptyMsg: boolean;
  public checked = false;
  public selectValueArr = [];
  public AllData: any = [];
  public clientId: any;
  public sitesList: any = [];
  public userList: any = [];
  public pageName: string;
  public _userList: any = [];
  public classAdd: any;
  public _siteUsersList: any = [];
  public breadcrumbsArray: any = [
    {
      page_ref: "site-groups",
      page_title: "site",
    },
  ];
  public siteArr: any = [];
  public showEmptyError = "";
  public company_name: string;
  public today: Date;
  constructor(
    public router: Router,
    private changeService: ChangeUsersService,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    private service: BackendApiService
  ) {
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
    activeRoute.queryParams.subscribe((params) => {
      this.pageName = params[`pageRef`];
      if (this.pageName === "managerAssets") {
        const myObj = {
          page_ref: "manager-client-list",
          page_title: "manager clients",
        };
        this.breadcrumbsArray.unshift(myObj);
      }
    });
  }

  utcTime() {
    setInterval(() => {
      const date = new Date().getHours();
      const houre = new Date().getMinutes();
      const second = new Date().getSeconds();
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  goToPageLink(name: string) {
    this.router.navigate([name]);
  }

  ngOnInit() {
    this.clientId = localStorage.getItem("user_id");
    if (this.clientId !== "") {
      this.getallSitesAndGroupsInfo(this.clientId);
    }
  }

  getallSitesAndGroupsInfo(clientid) {
    this.changeService.loader(true);
    this.service
      .getData(
        this.allSitesUrl +
          "/" +
          Math.floor(Math.random() * 90 + 10) +
          localStorage.getItem("user_id") +
          Math.floor(Math.random() * 9000 + 1000)
      )
      .then((res) => {
        this.changeService.loader(false);
        if (JSON.parse(JSON.stringify(res)).data.status === "success") {
          this.sitesList = JSON.parse(JSON.stringify(res)).data.body;
          this.siteArr = this.sitesList;
          console.log(this.sitesList, "siteslist");
          if (this.sitesList.length !== 0) {
            this.showList = true;
            this.emptyMsg = false;
          } else {
            this.showList = false;
            this.emptyMsg = true;
          }
        } else {
          this.showList = false;
          this.emptyMsg = true;
          this.service.showError("Something went wrong.");
        }
      });
  }

  searchData(ev) {
    const term = ev.trim().toLowerCase();
    this.siteArr = this.sitesList.filter(
      (result) => result.name.trim().toLowerCase().indexOf(term) >= 0
    );
    if (this.siteArr.length === 0) {
      this.showEmptyError = "Site and application not found.";
    } else {
      this.showEmptyError = "";
    }
  }

  showDeleteDialog(site_obj, index) {
    if (site_obj.device_count > 0) {
      this.service.showError("Please delete all associated devices first!");
      return;
    }
    if (site_obj.device_count >= 1) {
      this.service.showSuccess("Assets are associated with selected site");
    } else {
      const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
        width: "400px",
        height: "150px",
        data: {
          type: "delete-dialog-open",
          typeOf: "user",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result !== undefined) {
          this.deleteUser(site_obj, index);
        }
      });
    }
  }

  deleteUser(site_obj, index) {
    this.service
      .deleteInfo(this.deleteSiteUrl + "/" + site_obj.id)
      .then((res) => {
        if (
          JSON.parse(JSON.stringify(res)).message.includes(
            "successfully deleted"
          )
        ) {
          this.classAdd = index;
          this.siteArr.splice(index, 1);
          this.service.showSuccess("Successfully deleted.");
          if (this.siteArr.length === 0) {
            this.searchedItem = "";
            this.service.showSuccess("Successfully deleted.");
            this.ngOnInit();
          }
          if (site_obj.applications.length !== 0) {
            this.deleteApplication(site_obj);
          }
        } else {
          this.service.showSuccess("Something went wrong.");
        }
      });
  }

  deleteApplication(site_obj) {
    for (let v = 0; v < site_obj.applications.length; v++) {
      this.service
        .deleteInfo(
          this.applicationDeleteUrl + "/" + site_obj.applications[v].id
        )
        .then((res) => {
          if (
            JSON.parse(JSON.stringify(res)).data.message.includes(
              "successfully deleted"
            )
          ) {
          } else {
            this.service.showSuccess("Something went wrong.");
          }
        });
    }
  }

  async addClients() {
    console.log(this.sitesList, "helloaddsitelist");
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        sites: JSON.stringify(this.sitesList),
        pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
      },
    };
    this.router.navigate(["/add-site-and-groups"], navigationExtras);
  }

  editSiteGroup(objSite) {
    console.log(this.sitesList, "helloeditsitelist");
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        sites: JSON.stringify(this.sitesList),
        pid: true,
        pageType: "edit-site",
        pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
        siteObj: JSON.stringify(objSite),
      },
    };
    this.router.navigate(["/add-site-and-groups"], navigationExtras);
  }

  showListOfUsers(id, idx) {
    document.getElementById("associated_" + idx).style.pointerEvents = "none";
    this._siteUsersList = [];
    this._userList = [];
    this.userList = [];
    let _associateUsers: any = 0;
    const body = {
      client_id: localStorage.getItem("user_id"),
    };
    const siteUserBody = {
      site_id: id,
    };
    this.service
      .postData(this.siteUsersListingUrl, siteUserBody)
      .then((response) => {
        document.getElementById("associated_" + idx).style.pointerEvents =
          "auto";
        this._siteUsersList = JSON.parse(JSON.stringify(response)).data.body;
        this.service.postData(this.userListingUrl, body).then((res) => {
          this.changeService.loader(false);
          if (JSON.parse(JSON.stringify(res)).data.status === "success") {
            this.userList = JSON.parse(JSON.stringify(res)).data.body;
            if (this.userList.length > 0) {
              for (let i = 0; i < this.userList.length; i++) {
                let user = this._siteUsersList.filter(
                  (data) => data.user_id == this.userList[i].id
                );
                if (user != null && user.length > 0) {
                  _associateUsers = this._siteUsersList.length;
                  this._userList.push({
                    id: user[0].id,
                    userid: this.userList[i].id,
                    full_name: this.userList[i].full_name,
                    email: this.userList[i].email,
                    checked: true,
                  });
                } else {
                  this._userList.push({
                    id: null,
                    userid: this.userList[i].id,
                    full_name: this.userList[i].full_name,
                    email: this.userList[i].email,
                    checked: false,
                  });
                }
              }
            }
            const dialogRef = this.dialog.open(
              DialogOverviewExampleDialogComponent,
              {
                width: "650px",
                data: {
                  type: "managerClientSiteGroup",
                  userList: this._userList,
                  siteid: id,
                  _associateUsers: _associateUsers,
                },
              }
            );
          } else {
            this.showList = false;
            this.emptyMsg = true;
            this.service.showError("Something went wrong.");
          }
        });
      });
  }

  showAssetsList(id, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
        siteID: id,
        siteName: name,
      },
    };
    this.router.navigate(["device-reports/"], navigationExtras);
  }

  showGroupList(id, name) {
    const navigationExtras = {
      skipLocationChange: true,
      queryParams: {
        pageRef: "managerAssets" === this.pageName ? "managerAssets" : "",
        siteID: id,
        siteName: name,
      },
    };
    this.router.navigate(["client-group-list/"], navigationExtras);
  }

  siteView(description) {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialogComponent, {
      width: "650px",
      data: {
        type: "viewSite",
        des: description,
      },
    });
  }
}
